module.exports = __webpack_public_path__ + "static/media/tachometer-alt-average.9387ef23.svg";